import * as React from 'react'
import classNames from 'classnames'

import type { Props as ArticleProps } from '../ArticleSummary'

import ArticleSummary from '../ArticleSummary'
import Button from 'content-components/_Primatives/Button'
import Loader from 'content-components/_Primatives/Loader'
import Paragraph from 'content-components/_Primatives/Paragraph'

import style from './style.scss'

export type Props = {
  articles?: Omit<ArticleProps, 'commentLabelText'>[]
  className?: string
  commentLabelText: string
  hasMore: boolean
  isLoading: boolean
  isLoadingMore: boolean
  loadMoreText: string
  noResultsFoundText: string
  onLoadMore: () => void
}

function LandingPageArticleList(props: Props) {
  const {
    articles = [],
    className,
    loadMoreText,
    onLoadMore,
    noResultsFoundText,
    isLoading = false,
    isLoadingMore = false,
    hasMore,
    ...commentButton
  } = props

  return isLoading ? (
    <Loader />
  ) : (
    <section className={classNames(style.wrapper, className)}>
      {articles.length === 0 ? (
        <Paragraph>{noResultsFoundText}</Paragraph>
      ) : (
        <>
          {articles.map((article) => (
            <ArticleSummary
              key={article.headlineText}
              className={style.article}
              {...commentButton}
              {...article}
            />
          ))}

          {!isLoadingMore && hasMore && (
            <div className={style.buttonWrapper}>
              <Button
                aria-label={loadMoreText} // Added for integration with analytics
                className={style.button}
                variant='primaryBlue'
                onClick={onLoadMore}
              >
                {loadMoreText}
              </Button>
            </div>
          )}
          {isLoadingMore && <Loader />}
        </>
      )}
    </section>
  )
}

export default LandingPageArticleList
